import {touchPointer} from './map-pointer.mjs';
import {bucket} from './bubbles.mjs';
import {drawPin, pinLabel, pinStyle, secondaryBadge} from './pins.mjs';
import {FOCUS_DIM} from './dot-variants.mjs';
import {stopsAt} from './map-geometry.mjs';
export const SELECTED_SCALE = 1.25;
// Share of the enlargement by zoom: none where the others are dots or small pins (z11 and out), full from the pin zoom on.
export const SELECTED_GROWTH = [[11, 0], [14, 1]];
export const POP_MS = 180;
export const selectedFactor = (scale, zoom) => 1 + (scale - 1) * stopsAt(SELECTED_GROWTH, zoom);
const reducedMotion = () => !!globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
// Desktop keeps the map visible beside the panel, so the selection is enlarged there; mobile sheets dim the map.
export const selectedScale = desktop => desktop ? SELECTED_SCALE : 1;
// A DOM overlay stays above every map symbol, independent of source refreshes and style loads.
// The canvas is drawn once at the full scale and shrunk with CSS to the zoom's factor, so the one pin grows in place (no second copy);
// selecting animates it from the ordinary pin size. The map symbol under it is hidden by the caller (onSelect).
export function selectedSite(map, maplibre, lookup, appearance, deselect, onSelect = () => {}) {
  let marker, id, canvas, renderKey, drawn = SELECTED_SCALE, popPending = false;
  const factor = () => selectedFactor(drawn, map.getZoom?.() ?? Infinity);
  function fit() { if (canvas?.style) canvas.style.scale = String(factor() / drawn); }
  function pop() {
    const f = factor();
    if (f <= 1.001 || reducedMotion() || !canvas?.animate) return;
    canvas.animate([{transform: `scale(${1 / f})`}, {transform: 'scale(1)'}], {duration: POP_MS, easing: 'cubic-bezier(.2,.8,.3,1)'});
  }
  function refresh() {
    if (!marker) return;
    const site = lookup(id);
    if (!site) {
      if (canvas) marker.getElement().replaceChildren();
      canvas = null; renderKey = null;
      return;
    }
    const counts = site.counts;
    const {theme, profile, secondary, scale = SELECTED_SCALE} = appearance();
    drawn = scale;
    const label = pinLabel(counts), color = bucket(counts);
    const badge = secondaryBadge({...counts,...site},secondary);
    const nextKey = JSON.stringify([globalThis.devicePixelRatio || 1,theme,label,pinStyle(color, theme, profile), badge,site.focused,site.rank,scale]);
    if (canvas && renderKey === nextKey) return;
    // Keep the element and canvas: status updates must not replace the static selection.
    if (canvas) drawPin(label, color, theme, canvas, profile, badge,site.rank,scale,globalThis.devicePixelRatio || 1);
    else {
      canvas = drawPin(label, color, theme, undefined, profile, badge,site.rank,scale,globalThis.devicePixelRatio || 1);
      marker.getElement().replaceChildren(canvas);
    }
    marker.getElement().style.opacity=site.focused===false?String(FOCUS_DIM):'1';
    renderKey = nextKey;
    fit();
    if (popPending) { popPending = false; pop(); }
  }
  return {get id() { return id ?? null; }, scale: factor, show(next, coords) {
    if (id !== next) popPending = true;
    id = next;
    if (!marker) {
      const el = document.createElement('div'); el.className = 'selected-site';
      el.onclick = event => { event.stopPropagation(); if (!touchPointer(event, map.getCanvas?.())) deselect(); };
      marker = new maplibre.Marker({element: el}).setLngLat(coords).addTo(map);
      map.on?.('zoom', fit);
    } else marker.setLngLat(coords);
    onSelect(id);
    refresh();
    if (popPending && canvas) { popPending = false; pop(); }
  }, refresh, clear() {
    map.off?.('zoom', fit); marker?.remove(); marker = null; id = null; canvas = null; renderKey = null; popPending = false; onSelect(null);
  }};
}
